"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WarningTriangleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "24",
  height: "23",
  viewBox: "0 0 24 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-1087.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(1088.000000, 345.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M11.2876514,9.31213954 C11.4803874,9.10437474 11.7341404,9 12.0460048,9 C12.4266344,9 12.6794189,9.13293009 12.8082324,9.4007596 C12.935109,9.66661978 13,10.0516247 13,10.5547897 C13,10.8501899 12.9845036,11.1514981 12.9544794,11.456745 L12.6687651,14.7750739 C12.6387408,15.1699254 12.5719128,15.473203 12.4702179,15.6839218 C12.3694915,15.8946406 12.2009684,16 11.966586,16 C11.7283293,16 11.5636804,15.8975946 11.4707022,15.6927838 C11.3786925,15.4889577 11.3118643,15.1787875 11.2721549,14.7612885 L11.0610169,11.5374877 C11.0213075,10.9092699 11,10.4582923 11,10.1845548 C11,9.81235054 11.0968523,9.52187368 11.2876514,9.31213954 Z M11.9932171,17 C12.2713178,17 12.5096899,17.0978474 12.7044573,17.2906067 C12.9011627,17.4853229 13,17.7201566 13,17.9970646 C13,18.3091977 12.9011627,18.553816 12.7025193,18.7328767 C12.503876,18.9109589 12.2713178,19 12.006783,19 C11.7374031,19 11.502907,18.9119374 11.3003876,18.7348337 C11.0998062,18.5596869 11,18.3131115 11,17.9970646 C11,17.7201566 11.0959302,17.4853229 11.2868217,17.2906067 C11.4806201,17.0978474 11.7151162,17 11.9932171,17 Z M11.1141685,0.535993005 C11.4885128,-0.178664335 12.5114872,-0.178664335 12.8858315,0.535993005 L23.8858315,21.535993 C24.2346011,22.2018258 23.7516472,23 23,23 L1,23 C0.248352841,23 -0.234601074,22.2018258 0.114168465,21.535993 L11.1141685,0.535993005 Z M12,3.155 L2.652,21 L21.347,21 L12,3.155 Z",
            fillRule: "nonzero"
          })
        })
      })
    })
  })]
});

WarningTriangleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = WarningTriangleIcon;
exports.default = _default;